import { render, staticRenderFns } from "./EventHistory.vue?vue&type=template&id=3c813c54&scoped=true&"
import script from "./EventHistory.vue?vue&type=script&lang=js&"
export * from "./EventHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c813c54",
  null
  
)

export default component.exports